"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CombineSectionSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CombineSectionSkeleton = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SkeletonRoot, {
    "data-testid": getTestId('combine-section-skeleton'),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CombineSectionContent, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CombineContentWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Description, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
            animation: "wave",
            variant: "text",
            width: 185,
            height: 32
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
            animation: "wave",
            variant: "text",
            width: 300,
            height: 21
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubscriptionItemsWrapper, {
          children: Array.from({
            length: _constants.MAX_MOBILE_ITEMS
          }).map((_, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton
          // eslint-disable-next-line react/no-array-index-key -- No other option for key
          , {
            animation: "wave",
            variant: "rounded",
            width: 80,
            height: 80
          }, `combine-item-skeleton-${index}`))
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        animation: "wave",
        variant: "circular",
        width: 24,
        height: 24
      })]
    })
  });
};
exports.CombineSectionSkeleton = CombineSectionSkeleton;